import React, { ReactElement } from 'react'
import Template from '../../HelperClass/Template/Row'
import Points from '../../HelperClass/Points'
import { SoccerRowProps } from '../../HelperClass/StandingsRowTypes'
import MatchCounter from '../../HelperClass/MatchCounter'
import ResultCounter from '../../HelperClass/ResultCounter'
import DifferenceDetail from '../../HelperClass/DifferenceDetail'
import StandingsForm from '../../HelperClass/StandingsForm'
import DifferenceOverview from '../../HelperClass/DifferenceOverview'

export type Props = SoccerRowProps

const SoccerRow = ({
    matchCounter,
    onRowPress,
    rank,
    tendency,
    onMorePress,
    leagueQualifierColor,
    competitorLogoUrl,
    competitorName,
    competitorLogoAlt,
    hasDivider,
    imageType,
    points,
    additionalInfoLabel,
    testID,
    drawCounter,
    lossCounter,
    winCounter,
    againstValue,
    forValue,
    form,
    difference,
    isCompetitorBold,
}: Props): ReactElement => {
    return (
        <Template
            rank={rank}
            testID={testID}
            tendency={tendency}
            onRowPress={onRowPress}
            competitorLogoUrl={competitorLogoUrl}
            leagueQualifierColor={leagueQualifierColor}
            onMorePress={onMorePress}
            competitorName={competitorName}
            additionalInfoLabel={additionalInfoLabel}
            competitorLogoAlt={competitorLogoAlt}
            hasDivider={hasDivider}
            imageType={imageType}
            isCompetitorBold={isCompetitorBold}
        >
            <MatchCounter matchCounter={matchCounter} width={[30, 30, 32]} />
            <ResultCounter
                format="WDL"
                drawCounter={drawCounter}
                lossCounter={lossCounter}
                winCounter={winCounter}
                width={[58, 58, 60]}
            />
            <DifferenceDetail againstValue={againstValue} forValue={forValue} width={[0, 0, 44]} />
            <DifferenceOverview difference={difference} width={[31, 31, 32]} />
            <Points points={points} width={[30, 30, 32]} />
            <StandingsForm form={form} />
        </Template>
    )
}

export default SoccerRow
